import isEmpty from 'lodash/isEmpty';
import { localContentPrefix } from '../../../../config';
import { http } from '../../../axios';
import { GenreListOut } from '../../../../store/apiLibx';

const url = `${localContentPrefix}/v1/localcontent/genres/standard`;
export const fetchStandardGenres = (fiction: boolean | undefined, category: string | undefined, searchQuery = '') => {
    const params = {
        fiction,
        category,
        ...(!isEmpty(searchQuery) ? { q: searchQuery } : {})
    };

    return http.get<GenreListOut>(url, { params }).then(response => response.data);
};
